import React from 'react'

import { PayoutTokenLink } from '../../../common/PayoutTokenLink'
import { AUTO_HALT_RESOLUTION_LABELS, IPayoutTicket } from '../payoutTickets.types'

type Props = {
  ticket: Pick<
    IPayoutTicket,
    'autoHaltResolution' | 'remainderRoute' | 'recreatedTicketToken' | 'recreatedFromToken' | 'transactions' | 'cashBox'
  >
}

const InfoRow: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
  <div className='row mb-7'>
    <label className='col-5 fw-bold text-muted'>{label}</label>
    <div className='col-7 fw-bolder fs-5 text-dark'>{children}</div>
  </div>
)

// Токен целиком не помещается в колонку значения — он стоит под подписью на всю ширину блока,
// в одну строку, с отступом от края подписи.
const TokenRow: React.FC<{ label: string; token: string }> = ({ label, token }) => (
  <div className='mb-7'>
    <div className='fw-bold text-muted mb-1'>{label}</div>
    <div className='fw-bold fs-7 text-nowrap ps-4'>
      <PayoutTokenLink token={token} />
    </div>
  </div>
)

/**
 * Строки блока «Информация»: что сделал с выплатой таймаут профиля мэтчинга — исход, остаток и
 * касса, на которую ушла выплата или остаток. Пока касса стоит на тикете, её показывает шапка
 * карточки; здесь — только касса с последней попытки, когда с тикета она уже очищена.
 */
export const TimeoutHaltInfo: React.FC<Props> = ({ ticket }) => {
  const { autoHaltResolution, remainderRoute, recreatedTicketToken, recreatedFromToken } = ticket
  if (!autoHaltResolution && !remainderRoute) return null

  const toLocal = autoHaltResolution === 'LOCAL_ADAPTER' || remainderRoute === 'LOCAL_ADAPTER'
  const attemptCashBox = [...(ticket.transactions ?? [])].reverse().find((t) => t.cashbox)?.cashbox
  const cashBox = toLocal && !ticket.cashBox?.title ? attemptCashBox : null

  return (
    <>
      <div className='separator separator-dashed mb-7' />
      {autoHaltResolution && (
        <>
          <InfoRow label='Остановка'>По таймауту</InfoRow>
          <InfoRow label='Исход'>{AUTO_HALT_RESOLUTION_LABELS[autoHaltResolution]}</InfoRow>
        </>
      )}
      {recreatedTicketToken && <TokenRow label='Остаток выплаты' token={recreatedTicketToken} />}
      {recreatedFromToken && <TokenRow label='Исходная выплата (остановлена по таймауту)' token={recreatedFromToken} />}
      {cashBox && <InfoRow label='Касса'>{cashBox}</InfoRow>}
    </>
  )
}
